import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { API_SERVICES_CONFIG, NonPaginatedResourceConfig, PortalHttpClient } from '../../api';
import { CampaignRequest } from './campaign.model';
import { SubscribeRequest } from './subscription.model';

@Injectable({
  providedIn: 'root',
})
export class SalesforceService {
  private readonly subscriptionResourceConfig: NonPaginatedResourceConfig;
  private readonly campaignResourceConfig: NonPaginatedResourceConfig;

  constructor(private readonly http: PortalHttpClient) {
    this.subscriptionResourceConfig = API_SERVICES_CONFIG.v3.subscription._configuration;
    this.campaignResourceConfig = API_SERVICES_CONFIG.v3.campaign._configuration;
  }

  public sendSubscriptionRequest(payload: SubscribeRequest, customRetryAttempts?: number): Observable<null> {
    return this.http
      .post<void>(this.subscriptionResourceConfig, {
        body: payload,
        retryOptions: { customRetryAttempts },
        httpOptions: {},
      })
      .pipe(map(() => null));
  }

  public sendCampaignRequest(payload: CampaignRequest, customRetryAttempts?: number): Observable<null> {
    return this.http
      .post<void>(this.campaignResourceConfig, {
        body: payload,
        retryOptions: { customRetryAttempts },
        httpOptions: {},
      })
      .pipe(map(() => null));
  }
}
